<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <!-- <span class="line-anchor">线路推荐</span> -->
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont-fluid">
            <div class="line-cont">
              <div class="v-line-desc text-overflow">
                {{ item.desc }}
              </div>
            </div>
            <span class="desc">集森林树屋/山野温泉/神马农场</span>
            <div v-maidian="'line_' + index" class="line-btm clear">
              <div class="price">
                <span class="price-span">{{
                  discount ? item.price * 0.8 : item.price
                }}</span>
                <mt-button @click="jumpToSight(item.linkId)" size="small"
                  >立即购买</mt-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              'https://dimg03.c-ctrip.com/images/200814000000wl9vr1F83_C_750_420_Q90.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 4134,
            tag:"全程0购物/纯玩/享全景",
            desc: '【2大5A级景区】宿天目湖畔5钻涵田度假村&泡涵田半山温泉【私享半山半岛】&南山竹海【登高 赏万亩竹海 深吸氧】+坐船赏天目湖山水园【湖光山色】',
            linkId:
              'https://touch.dujia.qunar.com/pg/cq-detail/index?pid=2984620744&ctrDepId=2&ctrId=29724874&routeId=87476100&listDep=%E4%B8%8A%E6%B5%B7',
            discountId: '3401723685',
          },
          {
            headImg:
              'https://dimg04.c-ctrip.com/images/0300v120008plpogrFE5A_C_750_420_Q90.jpg',
            tagList: ['雪山温泉', '草原'],
            tag:"全程0购物/纯玩/享全景",
            price: 2967,
            desc: '【温泉之旅|1单1团|全程GL8商务用车】天目湖精选5钻酒店【3大5A精华全含|南山竹海&山水园&御水温泉】看竹海 蠢萌胖哒大熊猫|赏湖光 山水园碧波|泡温泉 竹林新体验',
            linkId:
              'https://touch.dujia.qunar.com/pg/cq-detail/index?pid=1370426152&ctrDepId=2&ctrId=29151691&routeId=85646180&listDep=%E4%B8%8A%E6%B5%B7',
            discountId: '1534603695',
          },
        ]
      ],
    };
  },
  methods: {
    jumpToSight(linkId) {
      window.location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  margin-top: 10px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  &-box {
    padding-left: 15px;
    padding-right: 15px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 6px;
    z-index: 2;
    background-color: #fff;
    display: flex;
    &-box {
      position: relative;
      .bg-line {
        background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
          no-repeat;
        background-size: 100% auto;
        height: 20px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 7px;
      }
    }
  }
  &-desc {
    height: 32px;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 5px;
  }
  &-btm {
    padding: 7px;
    margin: 10px;
    position: relative;
    bottom: 10px;
    // background-color: #fef8e9;
    .price {
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 15px;
        float: left;
        color: #f3427f;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: '￥';
          font-size: 9px;
          position: relative;
        }
        &:after {
          content: '起/人';
          font-size: 9px;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    width: 161px;
    img {
      display: block;
      height: 129px;
    }
  }
  .line-item {
    margin-bottom: 15px;
  }
  .line-cont-fluid {
    width: calc(100% - 161px);
    display: flex;
    font-size: 11px;
    height: 108px;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    line-height: 1.6;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: #f3427f;
    border-radius: 11px;
    color: #fff;
    font-size: 11px;
    height: 21px;
    margin-left: auto;
    margin-right: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10px;
    background: #f3427f;
    border-radius: 3px 0px 3px 0px;
  }
}
.v-line-desc{
  font-size:13px;
  line-height: 1.3;
}
.desc{
  font-size:11px;
  color: #999;
  padding-left: 4px;
}
.text-overflow {
  -webkit-line-clamp: 3;
}
</style>